import { useContext } from "react";
import { PortalContext } from "../Portal/index.js";
import { useIsInsideContainer } from "./useIsInsideContainer.js";
const useSearchSdkOutsideParentNode = ()=>{
    const isInsideContainer = useIsInsideContainer();
    const portalContext = useContext(PortalContext);
    if (!isInsideContainer) return null;
    const rootId = null == portalContext ? void 0 : portalContext.widgetContainerId;
    const shadowRootWrapper = rootId && document.getElementById(rootId) || null;
    if (!shadowRootWrapper) return null;
    let node = shadowRootWrapper;
    while(node){
        const style = window.getComputedStyle(node);
        const scrollable = 'auto' === style.overflowY || 'scroll' === style.overflowY;
        if (scrollable) return node;
        node = node.parentElement;
    }
    return null;
};
export { useSearchSdkOutsideParentNode };
